





















































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import {
  getIosAppInfo,
  getAndroidAppInfo,
  addEditIosApp,
  addEditAndroidApp
} from '@/api/files/files-app/filesApp'
import { getTagCategory, addTag, getTagList } from '@/api/files/files-base/filesBase'
import {
  getLangType,
  getLabelMapping,
  getTagMapping,
  getCatagoryMapping,
  getAndroidCategories
} from '@/api/common'
import { uploadVideoUrl, deleteFile } from '@/api/upload'
import { ElUploadInternalFileDetail } from '@/typings/files'
import { checkNoneString, resetObjValue2NoneString } from '@/utils/tool'
import { isArray } from 'lodash'
import { Form } from 'element-ui'
import { getImgURLOfBase64, getCookie } from '@/utils/fix'
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'EditApp'
})
export default class extends mixins(DisplayMixin) {
  // api data
  // params: IIOsAddEdit = {
  //   type: 'save',
  //   draftId: 0,
  //   id: 0,
  //   name: '',
  //   developer: '',
  //   tag: [1],
  //   subScript: [],
  //   desc: '',
  //   updateDesc: '',
  //   editorDesc: '',
  //   icon: '',
  //   screenShot: [],
  //   filePath: 'test',
  //   defaultLang: '',
  //   supportLang: '',
  //   categoryId: '',
  //   categoryCode: '',
  //   coverPath: '',
  //   videoPath: '',
  //   screen: 'vertical',
  //   uploadUrl: 'local',
  //   horizontalScreenShot: [],
  //   searchWeight: 0
  // }
  params: any = {
    id: 0,
    name: '',
    developer: '',
    tag: [],
    subScript: [],
    icon: '',
    screenShot: [],
    horizontalScreenShot: [],
    categoryId: 0,
    categoryCode: '',
    price: 0,
    searchWeight: 10,
    appleArcade: 1,
    descList: [],
    keywords: '',
    description: ''
  }
  categoryId: number[] = [0, 0]
  uploadUrl = 'outer'
  screen = 'vertical'
  currentParams: any = {
    appName: '',
    desc: '',
    updateDesc: '',
    editorDesc: ''
  }
  paramsList: any = {}
  supportLang: string[] = []
  tableLoading = false
  currentLang: string = ''
  // data
  /* 由于要使用饿了么ui的组件, 这里categoryOption原来的id 字段和 name 字段分别被改为 value 和 label,
  并且由于后台可能会传来null之类空的数据, 需要 null || []这样的写法来兼容数据结构的错误
  */
  private fileList: any[] = []
  private options: object[] = []
  public categoryOption: any[] = []
  public tagOption: any[] = []
  public subOption: any[] = []
  private platform: number = 1
  private cateList: ISelectItem[] = []
  private uploadVideoUrl = uploadVideoUrl
  // file response data
  private version = ''
  private versionCode = 0
  private bundleId = ''
  private md5 = ''
  private size = 0
  private ext = ''
  private value = []
  private ready: boolean = false
  private icon: string = 'data:image/png;base64,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'
  private playerOptions: any = {
    // 播放速度
    playbackRates: [0.5, 1.0, 1.5, 2.0],
    // 如果true,浏览器准备好时开始回放。
    autoplay: false,
    // 默认情况下将会消除任何音频。
    muted: false,
    // 导致视频一结束就重新开始。
    loop: false,
    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
    preload: 'auto',
    language: 'zh-CN',
    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
    aspectRatio: '16:9',
    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
    fluid: true,
    sources: [{
      // 类型
      type: 'video/mp4',
      // url地址
      src: ''
    }],
    // 你的封面地址
    // poster: '',
    // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
    // notSupportedMessage: '此视频暂无法播放，请稍后再试',
    controlBar: {
      timeDivider: true,
      durationDisplay: true,
      remainingTimeDisplay: false,
      // 全屏按钮
      fullscreenToggle: true
    }
  }
  private multiLanguage: string[] = []
  private score: number = 0
  playUrl: string = ''
  private addFormVisible: boolean = false
  private addParams = {
    id: 0,
    name: '',
    category: '',
    picPath: ''
  }
  private rules: any = {
    name: [{ required: true, message: '请输入标签名', trigger: 'blur' }],
    category: [{ required: true, message: '请选择类别', trigger: 'change' }]
  }

  // lifecycle
  created() {
    this.getEditDetail()
    this.getLangType()
    this.getTagList()
    this.getSubList()
    this.getTagCategory()
  }
  // methods
  async getEditDetail() {
    let p = this.$route.query.platform
    this.params.id = Number(this.$route.query.id)
    this.platform = p === 'ios' ? 1 : 3
    if (p === 'ios') {
      this.getIosDetail(this.params.id)
    } else {
      this.getAndroidDetail(this.params.id)
    }
    this.getCateList()
  }
  async getLangType() {
    let p = this.$route.query.platform
    let res = await getLangType({
      platform: p
    })
    this.options = res.data
  }
  async getCateList() {
    let p = this.$route.query.platform
    let res: any = p === 'ios' ? await getCatagoryMapping() : await getAndroidCategories()
    this.categoryOption = res.data.dataList
    this.categoryOption.forEach(item => {
      let { label, value, code } = item
      if (this.params.categoryId === value) {
        this.categoryId = [value]
      }
      if (Array.isArray(item.children)) {
        // item.children.unshift({ value, code, label, children: null })
        item.children.forEach((child: any) => {
          if (this.params.categoryId === child.value) {
            this.categoryId = [value, child.value]
          }
        })
      }
    })
  }

  async getTagCategory() {
    let res = await getTagCategory()
    this.cateList = res.data
  }

  async getIosDetail(id: number) {
    let res: any = await getIosAppInfo({ id })
    let item = res.data
    const { descList } = item
    // 语言
    this.multiLanguage = descList.map((item: any) => item.langCode)
    let obj: any = {}
    for (let item of descList) {
      obj[(item as any)['langCode']] = item
    }
    this.paramsList = obj
    this.currentParams = descList[0] || {}
    this.currentLang = this.currentParams.langCode
    this.params.id = item.id
    this.params.name = item.name
    this.params.developer = item.developer
    item.supportLang && (this.supportLang = item.supportLang.split(','))
    this.params.categoryCode = item.categoryCode
    this.params.categoryId = item.categoryId
    this.params.tag = item.tag ? item.tag.map((t: any) => t.id) : []
    item.subScript && (this.params.subScript = (item.subScript.map((s: any) => s.id) || []))
    this.params.icon = item.icon
    this.params.screenShot = item.screenShot || []
    this.params.horizontalScreenShot = item.horizontalScreenShot || []
    this.params.appleArcade = +item.appleArcade
    this.params.price = +item.price
    this.params.searchWeight = +item.searchWeight
    this.params.keywords = item.keywords
    this.params.description = item.description
    this.$nextTick(() => {
      this.ready = true
    })
  }

  monoId(id: number) {
    const first = [34, 35]
    return first.indexOf(id) > -1 ? [id, id] : id
  }
  async getAndroidDetail(id: number) {
    let res = await getAndroidAppInfo({ id })
    let item = res.data
    const { descList } = item
    // 语言
    this.multiLanguage = descList.map((item: any) => item.langCode)
    let obj: any = {}
    for (let item of descList) {
      obj[(item as any)['langCode']] = item
    }
    this.paramsList = obj
    this.currentParams = descList[0] || {}
    this.currentLang = this.currentParams.langCode
    this.params.id = item.id
    this.params.name = item.name
    this.params.developer = item.developer
    this.params.categoryCode = item.categoryCode
    this.params.categoryId = item.categoryId
    this.params.tag = (item.tag.map((t: any) => t.id) || [])
    item.supportLang && (this.supportLang = item.supportLang.split(','))
    item.subScript && (this.params.subScript = (item.subScript.map((s: any) => s.id) || []))
    this.params.icon = item.icon
    this.params.screenShot = item.screenShot || []
    this.params.horizontalScreenShot = item.horizontalScreenShot || []
    this.params.appleArcade = +item.appleArcade
    this.params.price = +item.price
    this.params.searchWeight = +item.searchWeight
    this.params.videoPath = item.videoPath
    this.params.coverPath = item.coverPath || ''
    this.params.keywords = item.keywords
    this.params.description = item.description
    this.$nextTick(() => {
      this.ready = true
    })
  }
  handleRead() {
    let url: string = this.params.videoPath
    if (!url.startsWith('http')) {
      url = 'https://' + url
    }
    this.playUrl = decodeURI(url)
    console.log(this.playUrl)
  }
  async getTagList() {
    let res: any = await getLabelMapping()
    this.tagOption = res.data.dataList
  }
  async getSubList() {
    let res: any = await getTagList({
      page: 1,
      pageCount: 50
    })
    this.subOption = res.data.dataList
  }
  async addIosApp() {
    let res: any = await addEditIosApp(this.params)
    if (+res.status.code === 0) {
      if (this.params.type === 'save') {
        this['$message'].success('保存成功')
      } else {
        this['$message'].success('提交审核成功')
      }
      this.$router.push('/files/files-app/files-app-ios')
    }
    this.tableLoading = false
  }
  async addAndroidApp() {
    let res: any = await addEditAndroidApp(this.params)
    if (res.status.code === 0) {
      if (this.params.type === 'save') {
        this['$message']('已保存至草稿箱')
      } else {
        this['$message'].success('操作成功，已提交审核，请耐心等待')
      }
      this.$router.push('/files/files-app/files-app-android')
    } else {
      this['$message'].error('提交失败，请稍后重试或联系相关人员')
    }
  }
  getPosition(item: any) {
    return item.categoryId
  }
  handleSelect(val: string[]) {
    if (val.length > 0) {
      this.currentLang = val[0]
    } else {
      this.currentLang = ''
    }
    let obj: any = {}
    for (let code of val) {
      if (this.paramsList[code]) {
        obj[code] = this.paramsList[code]
      } else {
        obj[code] = {
          // developer: '',
          appName: '',
          desc: '',
          updateDesc: '',
          editorDesc: ''
        }
      }
    }
    this.paramsList = obj
    this.currentParams = { ...this.paramsList[this.currentLang] }
  }
  handleLanguageChange(code: string) {
    this.paramsList[this.currentLang] = { ...this.currentParams }
    this.currentLang = code
    if (this.paramsList[code]) {
      this.currentParams = { ...this.paramsList[code] }
    } else {
      this.currentParams = {
        // developer: '',
        appName: '',
        desc: '',
        updateDesc: '',
        editorDesc: ''
      }
    }
  }
  cancelAddForm() {
    this.addFormVisible = false
  }
  toggleSelect(id: number) {
    let index: number = this.params.subScript.indexOf(id)
    if (index > -1) {
      this.params.subScript.splice(index, 1)
    } else {
      this.params.subScript.push(id)
    }
    if (this.params.subScript.length > 1) {
      this.params.subScript.shift()
    }
  }
  confirmAddForm() {
    if (this.addParams.name.length <= 0) {
      return this.$message.warning('请输入角标名')
    }
    if (!this.addParams.category) {
      return this.$message.warning('请选择角标位置')
    }
    if (!this.addParams.picPath) {
      return this.$message.warning('请上传角标图片')
    }
    this.addTag()
  }
  handleFormClose() {
    this.addParams.name = ''
    this.addParams.category = ''
    this.addParams.picPath = ''
  }
  async addTag() {
    let res: any = await addTag(Object.assign(this.addParams, {
      picPath: this.addParams.picPath.split(domain).pop() as string
    }))
    if (res.status.code === 0) {
      this['$message'].success('添加成功!')
      resetObjValue2NoneString(this.addParams, ['id'])
      this.addFormVisible = false
    } else {
      this['$message'].error('添加失败!')
    }
  }
  handleCategoryChange(v: number[]) {
    // console.log(v)
    let id: number = v[1]
    for (let i = 0; i < this.categoryOption.length; i++) {
      let child = this.categoryOption[i]
      if (child.value === v[0]) {
        this.params.categoryCode = child.code
        this.params.categoryId = child.value
      }
      const item = this.categoryOption[i]['children']
      if (Array.isArray(item)) {
        item.forEach((term: any) => {
          if (term.value === id) {
            this.params.categoryCode = term.code
            this.params.categoryId = term.value
          }
        })
      }
    }
  }
  handeSubmit(type: 'save' | 'commit') {
    this.tableLoading = true
    // this.params.type = type
    this.paramsList[this.currentLang] = this.currentParams
    console.log(this.paramsList)
    const arr = Object.keys(this.paramsList).map((langCode: string) => {
      return {
        ...this.paramsList[langCode],
        langCode,
        supportLang: this.supportLang.toString()
      }
    })
    this.params.descList = arr
    this.params.price = +this.params.price
    let tempParams = JSON.parse(JSON.stringify(this.params))
    let isNoneString = checkNoneString(tempParams, [
      'id',
      'draftId',
      'subScript',
      'editorDesc',
      'supportLang',
      'developer',
      'updateDesc',
      'videoPath',
      'coverPath',
      'tag',
      'screenShot',
      'horizontalScreenShot',
      'appleArcade',
      'name'
    ])
    let isArrNeed = this.params.screenShot.length + this.params.horizontalScreenShot.length > 0
    console.log(this.params)
    // return false
    // 保存不需要验证
    if (type === 'save') {
      if (this.platform === 1) {
        this.addIosApp()
      } else {
        this.addAndroidApp()
      }
    } else {
      console.log(this.paramsList)
      if (isNoneString || !isArrNeed) {
        this['$message'].warning('请填写完成后再提交!')
        return
      }
      if (this.platform === 1) {
        this.addIosApp()
      } else {
        this.addAndroidApp()
      }
    }
    // let query: IQuery = {
    //   id: this.params.id,
    //   platform: this.$route.query.platform
    // }
    // this['$router'].push({
    //   name: 'AppDetail',
    //   query: query
    // })
    // this.tableLoading = false
  }
  addLang() {
    let query: IQuery = {
      id: this.params.id,
      platform: this.$route.query.platform
    }
    this['$router'].push({
      name: 'MultiLanguage',
      query: query
    })
  }
  beforeFileUpload(file: ElUploadInternalFileDetail) {
    console.log(file)
  }
  handleFileSuccess(res: any, file: ElUploadInternalFileDetail) {
    if (res.status.code === 0) {
      this['$message'].success('视频上传成功')
      this.params.videoPath = res.data.path
      this.version = res.data.version
      this.versionCode = res.data.versionCode
      this.bundleId = res.data.bundleId
      this.md5 = res.data.md5
      this.size = res.data.size
      this.ext = res.data.ext
    } else {
      this['$message'].error('文件上传失败')
    }
  }
  handleFileError() {
    this['$message'].error('文件类型不支持，IOS支持ipa，Android支持apk和tpk')
  }
  handleExceed() {
    this['$message'].warning('最多只能上传一个文件!')
  }
  async handleRemove(file: ElUploadInternalFileDetail) {
    let path: string = file.name
    this.params.videoPath = ''
    let res: any = await deleteFile({
      path: path,
      id: this.params.id
    })
    if (res.status.code === 0) {
      this['$message'].success('文件删除成功')
    } else {
      this['$message'].error('文件删除失败')
    }
  }
  get plat() {
    return this.$route.query.platform
  }
  get computedVideoPath() {
    let { videoPath } = this.params
    if (videoPath.includes('http')) {
      return videoPath
    } else {
      return domain + videoPath
    }
  }
  get selectedLanguages() {
    return this.options.filter((item: any) => this.multiLanguage.includes(item.code))
  }
}
